
const 	cf7 = document.querySelectorAll('.wpcf7-form');

cf7.forEach( item => {
	
	let submitButton = item.querySelector('input[type=submit]');

	submitButton.addEventListener('click', e => {
		item.classList.add('is-submitting');
	});
});

document.addEventListener( 'wpcf7submit', function( event ) {
    cf7.forEach( item => {
		item.classList.remove('is-submitting');
    });
}, false );

document.addEventListener( 'wpcf7invalid', function( event ) {
	grecaptcha.reset();
}, false );
